var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "white",
    stroke: "#F4F5F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 12.2025C21 11.61 20.9464 11.0475 20.8544 10.5H12.1954V13.8825H17.1533C16.931 14.9925 16.2797 15.93 15.3142 16.5675V18.8175H18.272C20.0038 17.25 21 14.94 21 12.2025Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1954 21C14.6782 21 16.7548 20.19 18.272 18.8175L15.3142 16.5675C14.4866 17.1075 13.4368 17.4375 12.1954 17.4375C9.79693 17.4375 7.76628 15.855 7.03831 13.7175H3.98851V16.035C5.49808 18.975 8.60153 21 12.1954 21Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03831 13.7175C6.84674 13.1775 6.74713 12.6 6.74713 12C6.74713 11.4 6.85441 10.8225 7.03831 10.2825V7.965H3.98851C3.36015 9.18 3 10.545 3 12C3 13.455 3.36015 14.82 3.98851 16.035L7.03831 13.7175Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1954 6.5625C13.5517 6.5625 14.7625 7.02 15.7203 7.9125L18.341 5.3475C16.7548 3.8925 14.6782 3 12.1954 3C8.60153 3 5.49808 5.025 3.98851 7.965L7.03831 10.2825C7.76628 8.145 9.79693 6.5625 12.1954 6.5625Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogin);
export default __webpack_public_path__ + "static/media/GoogleLogin.15677d1fd38c661b778cfca162d6a30c.svg";
export { ForwardRef as ReactComponent };